import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('remove_document', '/remove_documents', 'remove_document')
const reducer = generator.generate()

export default reducer
